import React, { useEffect, useState } from "react";
import { Table } from "reactstrap";
import "./Merge_extra_new.css";
import Details from "../More_details/Details";

export default function Merge_extra_new() {
  const [mergedData, setMergedData] = useState([]);
  const [isEmpty, setIsEmpty] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const [display, setdisplay] = useState(false);
  const [selectedTeam, setSelectedTeam] = useState(null);
  console.log("selected_teams is", selectedTeam);
  const [clicked, setClicked] = useState([]);
  const API_URL = process.env.REACT_APP_API_FAST || "http://192.168.1.103:8000";

  useEffect(() => {
    const loadMergeStatus = async () => {
      try {
        setIsLoading(true);

        const response = await fetch(
          `${API_URL}/merge_extra/status`
        );

        if (!response.ok) {
          throw new Error(`HTTP ${response.status}`);
        }

        const data = await response.json();

        console.log("Merge status:", data);

        setMergedData(data);
        setIsEmpty(data.length === 0);
      } catch (error) {
        console.error("Failed to load merge status:", error);
        setIsEmpty(true);
      } finally {
        setIsLoading(false);
      }
    };

    loadMergeStatus();
  }, []);
  useEffect(() => {
    const eventSource = new EventSource(
      `${API_URL}/merge_extra/events`
    );

    eventSource.onopen = () => {
      console.log("Merge SSE connected");
    };

    eventSource.addEventListener("merge_ready", (event) => {
      const row = JSON.parse(event.data);

      console.log("Merge update:", row);

      setMergedData((prev) => {
        const exists = prev.some((item) => item.Team_code === row.Team_code);

        if (exists) {
          return prev.map((item) =>
            item.Team_code === row.Team_code ? row : item
          );
        }

        return [...prev, row];
      });
    });

    eventSource.onerror = (error) => {
      console.error("Merge SSE error:", error);
    };

    return () => {
      console.log("Closing Merge SSE");

      eventSource.close();
    };
  }, []);

  // Skeleton rows
  const renderSkeletonRows = () => {
    return Array.from({ length: 8 }).map((_, index) => (
      <tr key={`skeleton-${index}`} className="skeleton-row">
        <td>
          <span className="skeleton-box schedule-skeleton"></span>
        </td>

        <td className="sticky-col">
          <span className="skeleton-box"></span>
        </td>

        <td className="sticky-col">
          <span className="skeleton-box"></span>
        </td>

        <td>
          <span className="skeleton-box league-skeleton"></span>
        </td>

        <td>
          <span className="skeleton-button"></span>
        </td>
      </tr>
    ));
  };

  const formatDateTime = (Team_code) => {
    if (!Team_code) return "";

    const dateTime = Team_code.split("_").slice(-2).join(" ");

    return dateTime.replace("_", " ");
  };

  const renderTableStatus = (row) => {
    const allReady = row.table1 && row.table2 && row.table3;

    if (allReady) {
      const isClicked = clicked.includes(row.Team_code);

      return (
        <div className="ready-actions">
          <button
            className={`more_button ${isClicked ? "clicked_button" : ""}`}
            onClick={() => {
              setdisplay(true);
              setSelectedTeam(row);

              setClicked((prev) =>
                prev.includes(row.Team_code) ? prev : [...prev, row.Team_code]
              );
            }}
          >
            {isClicked ? "Clicked" : "More"}
          </button>

          {isClicked && (
            <button
              className="clear-individual-button"
              title={`Clear ${row.Team_code}`}
              onClick={() => {
                setClicked((prev) =>
                  prev.filter((teamCode) => teamCode !== row.Team_code)
                );

                // Optional: close details if this is
                // the currently selected team
                if (selectedTeam === row.Team_code) {
                  setdisplay(false);
                  setSelectedTeam(null);
                }
              }}
            >
              ×
            </button>
          )}
        </div>
      );
    }

    return (
      <div className="table-status">
        <span className={row.table1 ? "status-ok" : "status-fail"}>
          T1 {row.table1 ? "✓" : "✗"}
        </span>

        <span className={row.table2 ? "status-ok" : "status-fail"}>
          T2 {row.table2 ? "✓" : "✗"}
        </span>

        <span className={row.table3 ? "status-ok" : "status-fail"}>
          T3 {row.table3 ? "✓" : "✗"}
        </span>

        <span className={row.table4 ? "status-ok" : "status-fail"}>
          T4 {row.table4 ? "✓" : "✗"}
        </span>
      </div>
    );
  };

  const renderAlgorithms = (row) => {
    if (!row.algorithms || row.algorithms.length === 0) {
      return <span className="no-algorithm">—</span>;
    }

    return (
      <div className="algorithms-list">
        {row.algorithms.map((algo, index) => (
          <div className="algorithm-item" key={algo.algo_id || index}>
            <span className="algorithm-prediction">{algo.prediction}</span>

            <span className="algorithm-confidence">{algo.confidence}%</span>
          </div>
        ))}
      </div>
    );
  };

  return (
    <>
      <div className="alg1_card  merge_extra_1">
        <div className="merge_data_container">
          <h1>MERGED</h1>
          <p className="row_count">{mergedData.length}</p>

          <button
            onClick={() => {
              localStorage.removeItem("clickedTeams");
              setClicked([]);
            }}
          >
            Clear clicked
          </button>

          <Table striped>
            <thead>
              <tr>
                <th>schedule</th>
                <th className="sticky-col">Home Team</th>
                <th className="sticky-col">Away Team</th>
                <th>League</th>
                <th>Algorithims</th>
                <th>Details</th>
              </tr>
            </thead>

            <tbody>
              {/* -------------------------------- */}
              {/* 1. LOADING → SHOW SKELETON       */}
              {/* -------------------------------- */}
              {isLoading ? (
                renderSkeletonRows()
              ) : /* -------------------------------- */
              /* 2. FINISHED BUT EMPTY             */
              /* -------------------------------- */
              mergedData.length === 0 || isEmpty ? (
                <tr>
                  <td colSpan="5" className="empty-table">
                    No final results available yet.
                  </td>
                </tr>
              ) : (
                /* -------------------------------- */
                /* 3. DATA AVAILABLE                */
                /* -------------------------------- */
                mergedData.map((row, index) => (
                  <tr
                    key={row.Team_code || index}
                    className={`trname ${
                      Number(row.HP_2) === 0 ? "table-danger" : ""
                    }`}
                  >
                    <td className="TeamA">{formatDateTime(row.Team_code)}</td>

                    <td className="TeamA sticky-col">{row.Home_Team}</td>

                    <td className="TeamB sticky-col">{row.Away_Team}</td>

                    <td className="opt_sel">{row.Selected_Option}</td>
                    <td className="algorithm-cell">{renderAlgorithms(row)}</td>
                    <td>{renderTableStatus(row)}</td>
                  </tr>
                ))
              )}
            </tbody>
          </Table>
        </div>
        {display && (
          <div className="details_overlay">
            <Details
              teamcode={selectedTeam.Team_code}
              odds={selectedTeam.odds}
              algorithms={selectedTeam.algorithms}
              setdisplay={setdisplay}
            />
          </div>
        )}
      </div>
    </>
  );
}
